// export const IS_DEV = process.env.NODE_ENV !== 'production'
export const IS_DEV = false
console.log('Dev?', IS_DEV)

export const ERROR_MESSAGE_REQUIRED = 'This field is required'
export const PRONOUNS = [
  { value: 'she/her', text: 'She/Her' },
  { value: 'he/him', text: 'He/Him' },
  { value: 'they/them', text: 'They/Them' }
]

export const DAO = 'Aragon' // The DAO ID

// Firebase
export const FUNCTION_REGION = 'europe-west3'
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB5BXmBIiyR9RKQhcPGqq_FHjIDTcMG2fw',
  authDomain: 'onboarding-3ca22.firebaseapp.com',
  projectId: 'onboarding-3ca22',
  storageBucket: 'onboarding-3ca22.appspot.com',
  messagingSenderId: '560988571536',
  appId: '1:560988571536:web:94240f11efe22d27bbd515',
  measurementId: 'G-0N7PE71TXR'
}

export const FIREBASE_AUTH_SETTINGS = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  // TODO: Change to a dedicated endpoint like /verify-login
  url: 'http://localhost:3000/about-us',
  handleCodeInApp: true
}
export const USER_COLLECTION = 'users'


export const WALLET_SUPPORTED_CHAIN_IDS = [1] // see src/services/wallet/chains.js

export const MAGIC_APIKEY = 'pk_live_02651DBD157176C3'
export const POSTHOG_APIKEY = 'phc_mJ32FHiUOwaxcwZi3oO3HDOXJ3ajCBRqR0a0VEC3Vgx'

// Active campaign
export const AC_APIKEY =
  'e5ed3cefe0eee74d585a9467810196f165d41a1f3b756bbeacc80ba05e958532445bc9ca'
export const AC_API_BASE = 'https://indexcoop.api-us1.com/api/3'
export const AC_API_ROUTE_CONTACTS = '/contacts'
export const AC_API_ROUTE_LISTS = '/contactLists'
export const AC_API_CONTACTS = AC_API_BASE + AC_API_ROUTE_CONTACTS
export const AC_API_LISTS = AC_API_BASE + AC_API_ROUTE_LISTS
export const AC_LISTID_NEWJOINER = 2
export const AC_LISTID_NEWSLETTER = 6

export const INFURA_KEY = 'f91c4d7aaec249a1a5907b1af70586c9'

export const SENTRY_DSN = 'https://1fb032d91e2a47c1a9da1b747a2afd0b@o1146337.ingest.sentry.io/6214932'
